/*
  Version:        1.1.3
  Site:           Athelon Group Internet Site
  Website:        athelon.biz
  Covers:         (.com, .net, .org)
  Framework:      React/Express
  Last updated:   2025-08-02
  Author:         Athelon Corporation
  email:          corporate@athelon.com
*/
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './components/styles.css';
import App from './App';

/*
  render initiates the "App" function (HTML code) and the first element in the DOM whose id="root"
*/
ReactDOM.render(
  <App />,
  document.getElementById('root')
);

